const typeLabelMap = {
  piece: "Piece",
  pack: "Pack ( 1 )",
  cart: "Carton ( 1 )",
  extra1: "Buy",
  extra2: "Buy",
  extra3: "Buy",
};

export const getCouponTypeLabel = (slab) => {
  if (!slab?.type) return "";
  return typeLabelMap[slab.type] || slab.type;
};

export const getCouponType = (type) => {
  if (!type) return "";
  return typeLabelMap[type] || type;
};

/**
 * Derive purchase type from product quantity fields when the API
 * doesn't provide a type field on discount_items.
 *
 * Matching priority: minorderqty -> packqty -> cartqty -> extra1
 */
export const deriveSlabType = (product, item) => {
  const qty = Number(item?.qty);
  const minorderqty = Number(product?.minorderqty);
  const packqty = Number(product?.packqty);
  const cartqty = Number(product?.cartqty);

  if (qty === minorderqty) return "piece";
  if (packqty > 0 && qty === packqty) return "pack";
  if (cartqty > 0 && qty === cartqty) return "cart";
  return "extra1";
};
